import CityPageTemplate from "../city-template/CityPageTemplate";
import { springCreekConfig } from "./data";

export default function SpringCreekPage() {
  return <CityPageTemplate config={springCreekConfig} />;
}